import React from "react";
import { Reveal } from "../Reveal";
import { useLang } from "../../i18n/LanguageContext";

export const WhyNortis = () => {
  const { t } = useLang();
  return (
    <section className="bg-[#092B35] py-28 md:py-36 relative overflow-hidden" data-testid="home-why-nortis">
      <div className="absolute inset-0 film-lines opacity-30" aria-hidden="true" />
      <div className="relative max-w-[1320px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14">
          <Reveal className="lg:col-span-5">
            <p className="eyebrow">{t.whyNortis.eyebrow}</p>
            <h2 className="mt-5 text-3xl md:text-4xl font-light tracking-tight text-white leading-[1.15]">
              {t.whyNortis.title}
            </h2>
            <p className="mt-6 text-base text-slate-400 leading-relaxed max-w-md">{t.whyNortis.copy}</p>
          </Reveal>
          <div className="lg:col-span-6 lg:col-start-7">
            {t.whyNortis.points.map((p, i) => (
              <Reveal key={p.title} delay={i * 0.08} y={18}>
                <div className="group border-b border-white/10 py-7 first:pt-0 flex gap-6 items-start" data-testid={`why-point-${i}`}>
                  <span className="text-xs font-semibold text-[#19C7C1] tracking-widest pt-1.5 tabular-nums">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div>
                    <h3 className="text-base md:text-lg font-semibold text-white group-hover:text-[#19C7C1] transition-colors duration-300">
                      {p.title}
                    </h3>
                    <p className="mt-2 text-sm text-slate-400 leading-relaxed">{p.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
